import { render } from "./productPriceSku.vue?vue&type=template&id=7f82ea84"
import script from "./productPriceSku.vue?vue&type=script&lang=js"
export * from "./productPriceSku.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/components/productPriceSku.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f82ea84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f82ea84', __exports__)) {
    api.reload('7f82ea84', __exports__)
  }
  
  module.hot.accept("./productPriceSku.vue?vue&type=template&id=7f82ea84", () => {
    api.rerender('7f82ea84', render)
  })

}


export default __exports__